/*
 * @Date: 2026-01-27 00:39:34
 * @LastEditors: ryan.zheng@momenta.ai
 * @LastEditTime: 2026-03-13 00:00:00
 */
import { Outlet } from 'ice';

// 布局和鉴权由 src/entry.tsx（icestark framework layout）统一处理
export default function Layout() {
  return <Outlet />;
}
